import { Building2, ShieldCheck, HeartPulse, TrendingUp, ClipboardList, ArrowRight } from "lucide-react";
import { Reveal, SectionTag } from "@/components/Reveal";

const CATEGORIES = [
  { icon: Building2, title: "Hospital Management", desc: "Insights for hospital owners, directors and administrators." },
  { icon: ShieldCheck, title: "Insurance & Cashless", desc: "Understand healthcare insurance and cashless processes." },
  { icon: HeartPulse, title: "Healthcare Awareness", desc: "Simple information for patients and families." },
  { icon: TrendingUp, title: "Healthcare Business", desc: "Ideas, opportunities and developments across the healthcare ecosystem." },
  { icon: ClipboardList, title: "Healthcare Administration", desc: "Practical knowledge for healthcare professionals and teams." },
];

export const Knowledge = () => (
  <section id="knowledge" className="relative bg-white py-24 sm:py-32">
    <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
      <Reveal>
        <SectionTag index="09" label="Healthcare Knowledge" />
        <h2 className="font-display mt-6 text-2xl font-bold tracking-tight text-[#0B3C5C] sm:text-3xl lg:text-4xl">
          Healthcare Knowledge. Simplified.
        </h2>
        <p className="mt-5 max-w-2xl text-base text-[#4A6B82] sm:text-lg">
          Stay informed through practical healthcare content created for professionals,
          hospitals, patients and the general public.
        </p>
      </Reveal>

      <div className="mt-14 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-5">
        {CATEGORIES.map((c, i) => (
          <Reveal key={c.title} delay={i * 0.07}>
            <div
              data-testid={`knowledge-card-${i + 1}`}
              className="group h-full cursor-pointer rounded-2xl border border-[#0B3C5C]/10 bg-[#EAF3F8]/60 p-6 transition-all duration-300 hover:-translate-y-1 hover:border-teal-500/30 hover:shadow-xl hover:shadow-teal-900/20"
            >
              <span className="font-mono-x text-[10px] uppercase tracking-[0.25em] text-[#7E9AAC]">
                Cat. {String(i + 1).padStart(2, "0")}
              </span>
              <span className="mt-4 flex h-11 w-11 items-center justify-center rounded-xl bg-[#5FA832]/10 transition-colors duration-300 group-hover:bg-[#5FA832]/20">
                <c.icon className="h-5 w-5 text-[#4C8F2F]" />
              </span>
              <h3 className="font-display mt-4 text-base font-semibold text-[#0B3C5C]">{c.title}</h3>
              <p className="mt-2 text-sm leading-relaxed text-[#4A6B82]">{c.desc}</p>
            </div>
          </Reveal>
        ))}
      </div>

      <Reveal delay={0.15}>
        <a
          href="/knowledge"
          data-testid="knowledge-cta-articles"
          className="group mt-12 inline-flex items-center gap-2 text-sm font-bold text-[#4C8F2F] transition-colors hover:text-[#5FA832]"
        >
          Explore All Articles
          <ArrowRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-1" />
        </a>
      </Reveal>
    </div>
  </section>
);
